import {
	AUTO_REFINANCE_PATH,
	BUSINESS_LOANS_DEFAULT_PATH,
	PERSONAL_LOANS_DEFAULT_PATH,
} from "../../../../config/site/thecreditreview";

export const styles = (vertical) => ({
	mainContainer: `container ${mainContainerVerticalStyles[vertical] || ""}`,
	companyListContainer:
		"col-xs-12 col-md-12 no-padding-right-sm no-padding-left-sm",
	paginationContainer:
		"tw:flex tw:justify-center tw:gap-2 tw:sm:mx-auto tw:mt-8 tw:mb-0",
	paginationListItem: "tw:p-0 tw:bg-none tw:m-0",
	previousListItem: "tw:p-0 tw:bg-none tw:m-0",
	nextListItem: "tw:p-0 tw:bg-none tw:m-0",
	pageLink:
		"tw:ml-2 tw:inline-flex tw:text-[#4A5059] tw:text-center tw:bg-white tw:capitalize tw:p-2.5 tw:px-4 tw:text-base tw:font-medium tw:leading-6 tw:shadow-[0px_4px_24px_-4px_rgba(90,97,107,0.07),0px_2px_6px_-2px_rgba(90,97,107,0.07),0px_1px_3px_-1px_rgba(90,97,107,0.07),0px_0px_1px_0px_rgba(90,97,107,0.25)] tw:rounded-[12px] tw:border-[0.5px] tw:border-solid tw:border-[rgba(22,34,51,0.07)] tw:sm:inline-flex",
	previousLink: "tw:hidden tw:mr-6",
	nextLink: "tw:ml-6",
	activeLink: "",
	disabledLink: "tw:opacity-50 tw:cursor-not-allowed",
});

const mainContainerVerticalStyles = {
	[AUTO_REFINANCE_PATH]: "tw:sm:mt-20px",
	[BUSINESS_LOANS_DEFAULT_PATH]: "tw:mt-0 tw:sm:mt-20px",
	[PERSONAL_LOANS_DEFAULT_PATH]: "tw:mt-0 tw:sm:mt-20px",
};
